var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"control is-horizontal section-header"},[_c('div',{staticClass:"control-label"},[_c('h3',{staticClass:"section-header__title"},[_vm._t("title",function(){return [(_vm.title)?_c('lang',{attrs:{"labelKey":_vm.title}}):_vm._e()]})],2)]),_c('div',{staticClass:"control section-header__content"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }